import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import classNames from "classnames";
import ReactSelect, { components, } from "react-select";
import CreatableSelect from "react-select/creatable";
import { Label } from "../Label/Label";
import { Icon } from "../Icon/Icon";
import { InputMessageGroup } from "../InputMessageGroup/InputMessageGroup";
// Custom DropdownIndicator component
const DropdownIndicator = (props) => {
    return (_jsx(components.DropdownIndicator, { ...props, children: _jsx(Icon, { name: "CaretDown", size: "m" }) }));
};
// Only render IndicatorSeparator if it is MultiSelect
const IndicatorSeparator = (props) => {
    // eslint-disable-next-line react/destructuring-assignment
    if (!props.selectProps.isMulti) {
        return null;
    }
    return _jsx(components.IndicatorSeparator, { ...props });
};
// Custom ClearIndicator component
const ClearIndicator = (props) => {
    return (_jsx(components.ClearIndicator, { ...props, children: _jsx(Icon, { name: "Close", size: "m" }) }));
};
// Custom MultiValueRemove component
const MultiValueRemove = (props) => {
    return (_jsx(components.MultiValueRemove, { ...props, children: _jsx(Icon, { name: "Close", size: "m" }) }));
};
export const Select = React.forwardRef(({ noBorder, errorMessage, id, label, subtitle, hasErrors, hideLabel = false, message, className, isCreatable, components: componentsInternal, ...rest }, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
ref) => {
    const [lastInteraction, setLastInteraction] = useState("mouse");
    useEffect(() => {
        const keyboardListener = () => setLastInteraction("keyboard");
        const mouseListener = () => setLastInteraction("mouse");
        window.addEventListener("keydown", keyboardListener);
        window.addEventListener("mousedown", mouseListener);
        return () => {
            window.removeEventListener("keydown", keyboardListener);
            window.removeEventListener("mousedown", mouseListener);
        };
    }, []);
    const style = {
        control: (base, state) => ({
            ...base,
            boxShadow: state.isFocused && lastInteraction === "mouse"
                ? "none"
                : base.boxShadow,
        }),
    };
    return (_jsxs("div", { children: [_jsx(Label, { htmlFor: id, font: "title-6", screenReaderOnly: hideLabel, hasErrors: hasErrors, children: label }), subtitle && (_jsx(Label, { htmlFor: id, font: "body-3", color: "text-secondary", children: subtitle })), _jsx("div", { className: classNames("eds-select eds-text-field", className), children: isCreatable ? (_jsx(CreatableSelect, { components: {
                        MultiValueRemove,
                        DropdownIndicator,
                        ClearIndicator,
                        IndicatorSeparator,
                        ...componentsInternal,
                    }, ref: ref, className: classNames("eds-text-field__input eds-text-field--select", {
                        "eds-text-field__input--error": hasErrors,
                        "eds-text-field__input--no-border": noBorder === true,
                    }), id: `${id}-wrapper`, inputId: id, "aria-describedby": `${id}-meta`, classNamePrefix: "eds-select", 
                    // onCreateOption={onCreateOption}
                    styles: style, ...rest })) : (_jsx(ReactSelect, { components: {
                        MultiValueRemove,
                        DropdownIndicator,
                        ClearIndicator,
                        IndicatorSeparator,
                        ...componentsInternal,
                    }, ref: ref, className: classNames("eds-text-field__input eds-text-field--select", {
                        "eds-text-field__input--error": hasErrors,
                        "eds-text-field__input--no-border": noBorder === true,
                    }), id: `${id}-wrapper`, inputId: id, "aria-describedby": `${id}-meta`, classNamePrefix: "eds-select", styles: style, ...rest })) }), (hasErrors || message) && (_jsx(InputMessageGroup, { id: `${id}-meta`, message: message, errorMessage: hasErrors && (errorMessage || "Error") }))] }));
});
